import axios from "axios";
import {API_PATH} from '../constants'
import {store} from './../Store';
import AuthService from '../lib/AuthService';
let authObj = new AuthService();
//alert(API_PATH)
/*let config = settings.pages.pageSettings.config;
fetch("config.json")
    .then(response => response.json())
    .then(data => {
        console.log(data);
        config = data;
    });*/
let user_id = '';
if(authObj.loggedIn()) {
    user_id = authObj.getProfile().user_id;
}
else {
    redirectToHome();
}

function redirectToHome() {
    if(window.location.pathname !== '/login' && !window.location.pathname.startsWith("/view-playlist")) {
        window.location.href = "/login";
    }
  /* window.location.href = "login";
    return false;*/
}

export  const commonService = {
    sendHttpRequest
}

function sendHttpRequest(URL , data, method) {
    let settings = store.getState();
    console.log("settings");
    console.log(settings);
    let config = settings.pages.pageSettings.config;
    console.log(config);
    var date = new Date(); var timestamp = date.getTime();

    var params = '';

    if(method === 'GET' && data) {
        params = data;
    }
    /*if(method === 'GET' && data) {

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var val = data[key];
                params += '&'+key+'='+val;
            }
        }
    }*/


    if( user_id !=='') {
        axios.get(API_PATH+'login/loglastactivity?user_id='+user_id)
            .then(function (res) {
                // handle success
                authObj.login(res.data.response);
            });
    }


    // Send an HTTP  request
    return axios({
        method: method,
        supportHeaderParams: true,
        url: config.API_PATH+URL+'?t='+timestamp,
        params : params,
        data: data,
        async:false
    }).then(function(res){
        console.log("success");
        if(res.data.response === 'failure' || Object.keys(res.data.response).length === 0) {
            return undefined;
        }
        return res;

    }).catch(function(err){
        console.log("error");
        console.log(err);
        return err;
    });
}



// WEBPACK FOOTER //
// ./src/services/common.services.js